import { render } from "./ModalSuppliers.vue?vue&type=template&id=8be7fe22"
import script from "./ModalSuppliers.vue?vue&type=script&lang=js"
export * from "./ModalSuppliers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__